var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50008 5.5V16.3167C5.50008 17.3434 5.50008 17.8565 5.6999 18.2486C5.87567 18.5936 6.15593 18.8746 6.5009 19.0504C6.89268 19.25 7.40583 19.25 8.43058 19.25H13.5696C14.5943 19.25 15.1067 19.25 15.4985 19.0504C15.8435 18.8746 16.1247 18.5936 16.3005 18.2486C16.5001 17.8568 16.5001 17.3443 16.5001 16.3195V5.5M5.50008 5.5H7.33341M5.50008 5.5H3.66675M7.33341 5.5H14.6667M7.33341 5.5C7.33341 4.64577 7.33341 4.21887 7.47297 3.88196C7.65904 3.43274 8.01571 3.07563 8.46493 2.88955C8.80184 2.75 9.22919 2.75 10.0834 2.75H11.9167C12.771 2.75 13.1981 2.75 13.535 2.88955C13.9842 3.07563 14.341 3.43274 14.5271 3.88196C14.6667 4.21887 14.6667 4.64578 14.6667 5.5M14.6667 5.5H16.5001M16.5001 5.5H18.3334",
    stroke: "#EC5B5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.6e43b30c89e3947032293f53ebb32185.svg";